const PWA_START_KEY = 'ds:pwa_start';

/** Rotas que não devem ser salvas como entrada do PWA (marketing). */
const SKIP_PWA_START = new Set(['/']);

/** Detecta app instalado (Android/desktop/iOS). */
export function isPwaStandalone(): boolean {
  if (typeof window === 'undefined') return false;

  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  if (window.matchMedia('(display-mode: fullscreen)').matches) return true;
  if (window.matchMedia('(display-mode: minimal-ui)').matches) return true;

  const nav = navigator as Navigator & { standalone?: boolean };
  return Boolean(nav.standalone);
}

/** Persiste última rota útil do app para reabrir o PWA no contexto correto. */
export function registerPwaStart(pathname: string): void {
  if (!isPwaStandalone()) return;
  if (SKIP_PWA_START.has(pathname)) return;

  try {
    localStorage.setItem(PWA_START_KEY, pathname);
  } catch {
    /* quota / modo privado */
  }
}

export function getPwaStartPath(): string | null {
  try {
    const path = localStorage.getItem(PWA_START_KEY);
    if (!path || path === '/') return null;
    return path;
  } catch {
    return null;
  }
}
